import React from 'react';
import { useHistory } from 'react-router';
import { Tooltip, IconButton, makeStyles } from '@material-ui/core';
import FlagOutlined from '@material-ui/icons/FlagOutlined';
import { useTranslation } from 'react-i18next';
import { useTour } from '@reactour/tour';
import { tourSteps } from '../../../TourSteps';
const useStyles = makeStyles((theme) => ({
  iconButton: {
    [theme.breakpoints.down(990)]: {
      marginRight: '10px',
      '& span span svg': {
        fontSize: '1.3rem'
      }
    },
    color: theme.palette.primary.main,
    position: 'relative',
    '&:hover': {
      color: 'white'
    }
  }
}));

const Tour = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { setIsOpen, setCurrentStep, setSteps } = useTour();
  const history = useHistory();

  const tourList = [
    'tour-dashboard',
    'tour-template',
    'tour-identity',
    'tour-bundle',
    'tour-document',
    'tour-finished',
    'tour-file',
    'tour-notification'];
  for (const tour of tourList) {
    const tourState = localStorage.getItem(tour);
    if (tourState === null) {
      localStorage.setItem(tour, true);
    }
  }
  return (
    <div>
      <Tooltip title={t('tour:tooltip')}>
        <IconButton
          aria-controls='simple-menu'
          aria-haspopup='true'

          onClick={() => {
            if (history.location.pathname === '/dashboard') {
              localStorage.setItem('tour-dashboard', true);
              setIsOpen(true);
              setCurrentStep(0);
            }
            if (history.location.pathname === '/identity') {
              localStorage.setItem('tour-identity', true);
              setIsOpen(true);
              setCurrentStep(0);
            }
            if (history.location.pathname === '/template') {
              localStorage.setItem('tour-template', true);
              // setSteps(tourSteps.createNewTemplate);
              setIsOpen(true);
              setCurrentStep(0);
            }
            if (history.location.pathname === '/document') {
              localStorage.setItem('tour-document', true);
              // setSteps(tourSteps.createNewDocument);
              setIsOpen(true);
              setCurrentStep(0);
            }
            if (history.location.pathname === '/document/finished') {
              localStorage.setItem('tour-finished', true);
              // setSteps(tourSteps.finished);
              setIsOpen(true);
              setCurrentStep(0);
            }
            if (history.location.pathname === '/bundle') {
              localStorage.setItem('tour-bundle', true);
              // setSteps(tourSteps.createNewBundle);
              setIsOpen(true);
              setCurrentStep(0);
            }

            if (history.location.pathname.includes('/document/detail')) {
              setSteps(tourSteps.document);
              setIsOpen(true);
              setCurrentStep(0);
            }
            if (history.location.pathname === '/file') {
              localStorage.setItem('tour-file', true);
              // setSteps(tourSteps.createNewHash);
              setIsOpen(true);
              setCurrentStep(0);
            }
            if (history.location.pathname === '/notification') {
              localStorage.setItem('tour-notification', true);
              // setSteps(tourSteps.createNewHash);
              setIsOpen(true);
              setCurrentStep(0);
            }
          }}
          className={classes.iconButton}
        >
          <FlagOutlined
            fontSize='large'
            style={{ color: 'white', cursor: 'pointer' }}
          />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default Tour;
